import { Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend, ComposedChart, Line, Brush } from 'recharts';
import { numberFormat } from '../../../config/numberFormat';


export default function SalesOrderChart({data}) {
  
  // Calculate total amounts and counts
  const totalAmount = data.reduce((sum, item) => sum + item.totalAmount, 0);
  if (totalAmount === 0) {
    return (
      <div style={styles.card}>
        <h3 style={styles.header}>Sale Order Summary</h3>
        <p style={{ color: "#999", fontStyle: "italic" }}>No data available</p>
      </div>
    );
  }

  return (
    <div style={styles.card}>
      <h3 style={styles.header}>Sale Order Summary</h3>
      <div>
        <ResponsiveContainer width="100%" height={400}>
          <ComposedChart data={data} margin={{ top: 20, right: 0, left: 40, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />

            {/* Y-axis left for amount */}
            <YAxis
              yAxisId="left"
              tickFormatter={numberFormat}
              label={{ value: '', angle: -90, position: 'insideLeft' }}
            />

            {/* Y-axis right for count */}
            <YAxis
              yAxisId="right"
              orientation="right"
              label={{ value: 'Count', angle: 90, position: 'insideRight' }}
            />

            <Tooltip
              formatter={(value, name) =>
                name.includes("Count") ? value : numberFormat(value)
              }
            />
            <Legend  />

            {/* Amount bars */}
            <Bar yAxisId="left" dataKey="totalAmount" fill="#4caf50" name="Total Amount" />
            <Bar yAxisId="left" dataKey="openOrderAmount" fill="#fbc02d" name="Open Amount" />
            <Bar yAxisId="left" dataKey="closeOrderAmount" fill="#2196f3" name="Closed Amount" />

            {/* Count lines */}
            <Line yAxisId="right" type="monotone" dataKey="orderCount" stroke="#e91e63" name="Order Count" />
            <Line yAxisId="right" type="monotone" dataKey="openOrderCount" stroke="#ff9800" name="Open Count" />
            <Line yAxisId="right" type="monotone" dataKey="closeOrderCount" stroke="#3f51b5" name="Closed Count" />

            <Brush dataKey="name" height={30} stroke="#4caf50" />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

const styles = {
  card: {
    padding: "20px",
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    fontFamily: "sans-serif"
  },
  header: {
    marginBottom: 16,
    fontSize: 18,
    fontWeight: 600,
    color: "#333"
  },
};